import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CtNavKeys } from '@cloud-twin-v2/navigation/ct-nav-keys';
import { AuthGuard } from '@common-modules/shared/auth/services/auth.guard';

const routes: Routes = [
  {
    path: 'model-versions',
    loadChildren: () =>
      import(`./model-version/model-version.module`).then((m) => m.ModelVersionModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.ModelVersions,
    },
  },
  {
    path: 'measurements',
    loadChildren: () => import(`./telemetry/telemetry.module`).then((m) => m.TelemetryModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.Measurements,
    },
  },
  {
    path: 'map',
    loadChildren: () => import(`./ct-map/ct-map.module`).then((m) => m.CtMapModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.Map,
    },
  },
  {
    path: 'security',
    loadChildren: () => import(`./ct-security/ct-security.module`).then((m) => m.CtSecurityModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.AdministrationModule,
    },
  },
  {
    path: 'workspaces',
    loadChildren: () =>
      import(`./ct-workspaces/ct-workspaces.module`).then((m) => m.CtWorkspacesModule),
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: CtNavKeys.Workspaces,
    },
  },
  { path: '', redirectTo: 'workspaces', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [],
})
export class CloudTwinAppRoutingModule {}
